/*
 * TurnDisabledView Messages
 *
 * This contains all the text for the TurnDisabledView component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  enabling: {
    id: 'app.components.TurnDisabledView.enabling',
    defaultMessage: 'Enabling Turn ...',
  },
  isDisabled: {
    id: 'app.components.TurnDisabledView.isDisabled',
    defaultMessage: 'Turn is currently disabled',
  },
  enableButton: {
    id: 'app.components.TurnDisabledView.enableButton',
    defaultMessage: 'Enable and start planning',
  },
});
